import React, { useState, useEffect } from 'react';
import './RichEditorModal.css';
import { useTranslation } from '../../redux/TranslationHelper';
import YooptaHtmlEditor from './YooptaEditor';

const RichEditorModal = ({ isOpen, onClose, initialContent, onSave, content }) => {
  const { t } = useTranslation();
  const [htmlContent, setHtmlContent] = useState('');
  const [editorMode] = useState('yoopta'); // yoopta, ckeditor, preview, htmledit
  
  // 초기 콘텐츠 설정
  useEffect(() => {
    if (isOpen) {

      // content와 initialContent 중 하나를 사용 (둘 다 있으면 content 우선)
      let initialData = content || initialContent;
      

      // 객체인 경우 그대로 사용 (Yoopta 블록 데이터)
      // 문자열인 경우 HTML로 처리
      if (typeof initialData === 'string') {
        setHtmlContent(initialData);
      } else if (typeof initialData === 'object' && initialData !== null) {
        // 객체인 경우 YooptaHtmlEditor에서 직접 처리
        setHtmlContent(''); // HTML은 비우고 블록 데이터는 YooptaHtmlEditor에서 처리
      } else {
        setHtmlContent('');
      }
    }
  }, [isOpen, initialContent, content]);
  
  const handleSave = () => {

    // HTML과 블록 데이터 모두 전달
    onSave(htmlContent, currentBlockData);
    onClose();
  };
  
  // HTML 직접 편집시 업데이트 함수
  const handleHtmlChange = (e) => {
    setHtmlContent(e.target.value);
  };

  // YooptaEditor 변경 사항 처리 (HTML과 블록 데이터 모두 처리)
  const handleCKEditorChange = (htmlData, blockData) => {

    setHtmlContent(htmlData || '');
    
    // 블록 데이터도 저장해두기 (저장 시 사용)
    if (blockData) {
      setCurrentBlockData(blockData);
    }
  };
  
  // Pure HTML 에디터 저장 핸들러
  const handlePureHtmlSave = (htmlContent, blocks) => {

    // HTML만 저장하고 블록 데이터는 null로 설정
    setHtmlContent(htmlContent);
    setCurrentBlockData(null);
    
    // 바로 저장 처리
    onSave(htmlContent, null);
    onClose();
  };
  
  // 현재 블록 데이터 상태 추가
  const [currentBlockData, setCurrentBlockData] = useState(null);
  
  // 커스텀 이미지 업로드 어댑터 (CK 에디터용, 나중에 필요시 사용)
  // const customImageUploadAdapter = (loader) => {
  //   return {
  //     upload: () => {
  //       return new Promise((resolve, reject) => {
  //         loader.file.then(async (file) => {
  //           try {
  //             const formData = new FormData();
  //             formData.append('file', file);
  //             formData.append('bucket', 'withcookie-bucket');
  //             formData.append('path', 'c/default');

  //             const res = await axios.post(
  //               `https://refrigerator.logipasta.com/v1/file`,
  //               formData,
  //               {
  //                 headers: {
  //                   'Content-Type': 'multipart/form-data',
  //                   'Access-Control-Allow-Origin': '*',
  //                 },
  //               }
  //             );

  //             if (res.data && res.data.file) {
  //               resolve({
  //                 default: res.data.file
  //               });
  //             } else {
  //               reject(t('이미지 URL을 가져올 수 없습니다.'));
  //             }
  //           } catch (err) {
  //             console.error(t('이미지 업로드 실패:'), err);
  //             reject(t('이미지 업로드에 실패했습니다.'));
  //           }
  //         });
  //       });
  //     }
  //   };
  // };

  if (!isOpen) return null;

  return (
    <div className="rich-editor-modal-overlay">
      <div className="rich-editor-modal">
        <div className="rich-editor-modal-header">
          <h2>{t('콘텐츠 편집')}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        {/* <div className="editor-mode-toggle">
          <button 
            className={editorMode === 'yoopta' ? 'active' : ''} 
            onClick={() => setEditorMode('yoopta')}
          >
            {t('Yoopta 에디터')}
          </button>
          <button 
            className={editorMode === 'ckeditor' ? 'active' : ''} 
            onClick={() => setEditorMode('ckeditor')}
          >
            {t('CK 에디터')}
          </button>
          <button 
            className={editorMode === 'preview' ? 'active' : ''} 
            onClick={() => setEditorMode('preview')}
          >
            {t('미리보기')}
          </button>
          <button 
            className={editorMode === 'htmledit' ? 'active' : ''} 
            onClick={() => setEditorMode('htmledit')}
          >
            {t('HTML 편집')}
          </button>
        </div> */}
        
        <div className="rich-editor-modal-body">
          {/* Yoopta Editor - 항상 렌더링하되 visibility로 제어 */}
          <div 
            className="yoopta-editor-container"
          style={{ 
            visibility: editorMode === 'yoopta' ? 'visible' : 'hidden',
            position: editorMode === 'yoopta' ? 'relative' : 'absolute',
            flex: editorMode === 'yoopta' ? '1' : '0',
            height: editorMode === 'yoopta' ? '100%' : '0',
            opacity: editorMode === 'yoopta' ? 1 : 0
          }}
        >
          <YooptaHtmlEditor
            key={`yoopta-modal-${isOpen ? 'open' : 'closed'}`} // 단순한 키로 변경
            initialData={content || initialContent}
            onChange={handleCKEditorChange}
            placeholder={t('여기에 내용을 입력하세요...')}
            editorKey="yoopta-modal-editor" // 고정된 키 사용
            autoFocus={false} // DOM 오류 방지를 위해 autoFocus 비활성화
            onPureHtmlSave={handlePureHtmlSave}
          />
        </div>
        
        {/* CKEditor 제거 - Yoopta만 사용 */}
        
        {editorMode === 'preview' && (
          <div className="preview-container">
            <div
              className="preview-content"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          </div>
        )}
        
        {editorMode === 'htmledit' && (
          <div className="html-edit-container">
            <textarea
              className="html-editor"
              value={htmlContent}
              onChange={handleHtmlChange}
              placeholder={t('HTML 코드를 직접 편집하세요...')}
            />
          </div>
        )}
        </div>
        
        <div className="rich-editor-modal-footer">
          <button className="cancel-button" onClick={onClose}>{t('취소')}</button>
          <button className="save-button" onClick={handleSave}>{t('저장')}</button>
        </div>
      </div>
    </div>
  );
};

export default RichEditorModal; 